
import { z, ZodObject } from 'zod';
import { AddressType } from '../entities';
import { LocaleSettings } from '../utilities';

export function getAddressValidator(type: AddressType): ZodObject<any> {

    let validator: ZodObject<any>;
    let postcode: any = null;
    let postalCode: any = null;
    let state: any = null;

    if (LocaleSettings.isUK) {
        postalCode = z.string();
        const postcodeToString = (postcode: string | number) => {
            return typeof postcode === 'number'
                ? postcode.toString()
                : postcode;
        }
        postcode = z.preprocess(postcodeToString, z.string().optional().nullable());
        state = z.string().optional().nullable();
    } else {
        const postcodeToString = (postcode: string | number) => {
            return typeof postcode === 'string'
                ? parseInt(postcode)
                : postcode;
        }

        state = z.string();
        postcode = z.preprocess(postcodeToString, z.number()).optional().nullable();
        postalCode = z.string().optional().nullable();
    }

    switch (type) {

        case AddressType.Coordinates: {

            validator = z.object({
                // type: z.literal(AddressType.Coordinate),
                lat: z.number().min(-90).max(90),
                lgn: z.number().min(-180).max(180),
                name: z.string().optional().nullable(),

                street1: z.string().optional().nullable(),
                street2: z.string().optional().nullable(),
                suburb: z.string(),
                state,
                postcode,
                postalCode,
                county: z.string().optional().nullable(),
                country: z.string().optional().nullable(),
                timezone: z.string(),

            });

            break;
        }

        case AddressType.What3Words: {

            validator = z.object({
                // type: z.literal(AddressType.What3Words),
                lat: z.number().min(-90).max(90),
                lgn: z.number().min(-180).max(180),
                name: z.string(),

                street1: z.string().optional().nullable(),
                street2: z.string().optional().nullable(),
                suburb: z.string(),
                state,
                postcode,
                postalCode,
                country: z.string().optional().nullable(),
                county: z.string().optional().nullable(),
                timezone: z.string(),

            });

            break;
        }

        default: {

            validator = z.object({
                // type: z.literal(AddressType.Standard),
                lat: z.number().min(-90).max(90).optional().nullable(),
                lgn: z.number().min(-180).max(180).optional().nullable(),

                name: z.string().optional().nullable(),
                street1: z.string().min(1),
                street2: z.string().optional().nullable(),
                suburb: z.string(),
                state,
                postcode,
                postalCode,
                country: z.string().optional().nullable(),
                county: z.string().optional().nullable(),
                timezone: z.string(),

            });

        }
    }

    validator.refine(({ postcode, postalCode }) => {
        if (!postalCode && !postcode) {
            return false;
        }
    });

    return validator;

}